module.exports = __webpack_public_path__ + "img/MOT.4aeb64fc.svg";